'use client'

import { useTrack } from '@/hooks/useTrack'
import { SignInButton, SignUpButton, SignedOut } from '@clerk/nextjs'
import { Button, Menu } from '@mantine/core'

export function AuthButtons() {
	const { track } = useTrack()
	return (
		<SignedOut>
			<div className="gap-2 hidden sm:flex">
				<Menu>
					<SignInButton
						signUpFallbackRedirectUrl="/minha-area"
						fallbackRedirectUrl="/minha-area"
						forceRedirectUrl="/minha-area"
						mode="modal"
					>
						<Button
							onClick={() => {
								track('auth_buttons_sign_in_clicked')
							}}
							size="sm"
							className="text-sm"
						>
							Entrar
						</Button>
					</SignInButton>
				</Menu>

				<Menu>
					<SignUpButton
						signInFallbackRedirectUrl="/minha-area"
						fallbackRedirectUrl="/minha-area"
						forceRedirectUrl="/minha-area"
						mode="modal"
					>
						<Button
							onClick={() => {
								track('auth_buttons_sign_up_clicked')
							}}
							size="sm"
							className="text-sm"
						>
							Cadastrar
						</Button>
					</SignUpButton>
				</Menu>
			</div>

			{/* Mobile: Single login button */}
			<div className="sm:hidden">
				<Menu>
					<SignInButton
						signUpFallbackRedirectUrl="/minha-area"
						fallbackRedirectUrl="/minha-area"
						forceRedirectUrl="/minha-area"
						mode="modal"
					>
						<Button
							onClick={() => {
								track('auth_buttons_sign_in_clicked')
							}}
							size="xs"
							className="text-xs"
						>
							Entrar
						</Button>
					</SignInButton>
				</Menu>
			</div>
		</SignedOut>
	)
}
